import axios from 'axios';
import https from 'https';
import { integratedApi } from './apiUrl';
import store from '@/store/index';

axios.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false });
axios.defaults.timeout = 20000; // ms
axios.defaults.retry = 4; // count
axios.defaults.retryDelay = 1000; // ms

const _integratedAxios = axios.create({
  baseURL: integratedApi,
  timeout: 5000,
});

/* 인터셉터 request */
_integratedAxios.interceptors.request.use(
  config => {
    const { accessToken } = store.state;

    config.headers.post['Content-Type'] = 'application/json';
    config.headers.put['Content-Type'] = 'application/json';
    config.headers.accessToken = accessToken ? accessToken : '';
    config.withCredentials = false;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/* 인터셉터 response */
// Add a response interceptor
_integratedAxios.interceptors.response.use(
  response => {
    // Do something with response data
    return response;
  },
  error => {
    var config = error.config;
    console.error('Network Error, Retry', config);
    if (error.response.data.path == '/login/msg') {
      alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.');
      window.location.href = '/login';
    } else {
      // If config does not exist or the retry option is not set, reject
      if (!config || !config.retry) {
        console.log('config.retry Not Exist');
        return Promise.reject(error);
      }

      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0;

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        // Reject with the error
        console.log('Retry Count Overflow');
        return Promise.reject(error);
      }

      // Increase the retry count
      config.__retryCount += 1;

      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        console.log('Create New Promise');
        setTimeout(function () {
          resolve();
        }, config.retryDelay);
      });

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function () {
        console.log('Recalls Axios to Retry');
        return _axios(config);
      });
    }
  }
);

export { _integratedAxios };
